/**
 * User validation schemas using Zod
 */

import { z } from 'zod';

export const UserProfileSchema = z.object({
  bio: z.string().max(500).optional(),
  website: z.string().url().optional(),
  socialMedia: z
    .object({
      instagram: z.string().optional(),
      tiktok: z.string().optional(),
      youtube: z.string().optional(),
      twitter: z.string().optional(),
    })
    .optional(),
  niche: z.string().max(100).optional(),
  averageEngagement: z.number().min(0).max(100).optional(),
});

export const CreateUserSchema = z.object({
  email: z.string().email('Invalid email format'),
  displayName: z
    .string()
    .min(2, 'Display name must be at least 2 characters')
    .max(100, 'Display name must be at most 100 characters'),
  password: z
    .string()
    .min(8, 'Password must be at least 8 characters')
    .regex(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/,
      'Password must contain at least one uppercase letter, one lowercase letter, and one number'
    ),
});

export const UpdateUserSchema = z.object({
  displayName: z
    .string()
    .min(2, 'Display name must be at least 2 characters')
    .max(100, 'Display name must be at most 100 characters')
    .optional(),
  profile: UserProfileSchema.partial().optional(),
});

export const LoginSchema = z.object({
  email: z.string().email('Invalid email format'),
  password: z.string().min(1, 'Password is required'),
});
